/* eslint-disable */
const __webpack_public_path__ = window.__webpack_public_path__;
/* eslint-enable */
